export const hasPropertyEqualto = ({ product, productDepartment, classNumber, subClassNumber }) => {
  if (!product?.info) return false;
  const propsToCheck = [productDepartment, classNumber, subClassNumber];
  const props = ['productDepartment', 'classNumber', 'subClassNumber'].map((prop) => parseInt(product?.info[prop], 10));
  return propsToCheck.every((item, i) => {
    if (item === null) return true;
    const prop = Array.isArray(item) ? item : [item];
    return prop.includes(props[i]);
  });
};